import React from 'react';

import { IconBadge } from 'client/components/IconBadge';
import { useT } from 'client/i18n/hooks/useT';
import { clickNavLink, clickedNavLinkGoogleAnalytics } from '../../events';
import { StyledNavLink } from '../../LinkStyles';
import { Badge, Nav } from './styles';
import { NavLinkProps } from '../../types';

type NavLinksProps = {
  links: NavLinkProps[];
  pathname: string;
  isTransparent: boolean;
  isScalableAnalyticsEnabled?: boolean;
};

export const NavLinks = ({
  links,
  pathname,
  isTransparent,
  isScalableAnalyticsEnabled,
}: NavLinksProps) => {
  const t = useT();
  const translatedNavLinks = {
    ads: t(
      'PublicWebsiteNavFooter.Ads',
      'Ads by Anchor',
      'Link to "Ads by Anchor" web page'
    ),
    blog: t('PublicWebsiteNavFooter.Blog', 'Blog', 'Link to "Blog" web page'),
    dashboard: t(
      'PublicWebsiteNavFooter.Dashboard',
      'Dashboard',
      'Link to "Dashboard" web page'
    ),
    episodes: t(
      'PublicWebsiteNavFooter.Episodes',
      'Episodes',
      'Link to "Episodes" web page'
    ),
    features: t(
      'PublicWebsiteNavFooter.Features',
      'Features',
      'Link to "Features" web page'
    ),
    money: t(
      'PublicWebsiteNavFooter.Money',
      'Money',
      'Link to "Money" web page'
    ),
    network: t(
      'PublicWebsiteNavFooter.Network',
      'Network',
      'Link to "Network" web page'
    ),
    switch: t(
      'PublicWebsiteNavFooter.SwitchToAnchor',
      'Switch to Anchor',
      'Link to "Switch to Anchor" web page'
    ),
  } as { [key: string]: any };

  return (
    <Nav>
      {links.map(
        ({
          label,
          key,
          to,
          href,
          isShowingNotificationBadge,
          notificationBadge,
          openInNewTab,
        }) => (
          <StyledNavLink
            fontSize={18}
            isActive={
              isScalableAnalyticsEnabled
                ? pathname.includes(to)
                : pathname === to
            }
            isDownloadLink={false}
            key={key}
            to={to}
            href={href}
            isTransparent={isTransparent}
            isScalableAnalyticsEnabled={isScalableAnalyticsEnabled}
            aria-label={`${translatedNavLinks[key]}${
              openInNewTab ? ' (navigates to a new site)' : ''
            }`}
            onClick={() => {
              clickNavLink({ link: key });
              clickedNavLinkGoogleAnalytics(label);
            }}
            className=""
            // If we send "_self" instead of undefined, React Router will not
            // clientside navigate in cases where we want it to.
            target={openInNewTab ? '_blank' : undefined}
          >
            <span>
              {translatedNavLinks[key]}
              {isShowingNotificationBadge && (
                <Badge>
                  <IconBadge
                    backgroundColor="green"
                    iconColor="#292F36"
                    width={10}
                    padding={1}
                    type={notificationBadge}
                  />
                </Badge>
              )}
            </span>
          </StyledNavLink>
        )
      )}
    </Nav>
  );
};
